import { defineStore } from "pinia";
import type { Language } from "../types/PersologOnlineTypes.ts";

const defaultLanguage: Language = "de";
const defaultTheme = "default" as ThemeType;

export type ThemeType = "default" | "high-contrast";

export const usePreferencesStore = defineStore("preferences", {
    state: () => ({
        selectedLanguage: defaultLanguage as Language,
        selectedTheme: defaultTheme,
    }),
    actions: {
        initLanguage(availableLocales: Language[]) {
            const storedLang = localStorage.getItem("selectedLanguage") as Language | null;
            if (storedLang && availableLocales.includes(storedLang)) {
                this.selectedLanguage = storedLang;
                return;
            }
            this.selectedLanguage = defaultLanguage;
        },
        setLanguage(lang: Language) {
            this.selectedLanguage = lang;
            localStorage.setItem("selectedLanguage", lang);
        },
        initTheme() {
            const storedTheme = localStorage.getItem("selectedTheme") as ThemeType | null;
            if (storedTheme && ["default", "high-contrast"].includes(storedTheme)) {
                this.selectedTheme = storedTheme;
                return;
            }
            this.selectedTheme = defaultTheme;
        },
        setTheme(theme: ThemeType) {
            this.selectedTheme = theme;
            localStorage.setItem("selectedTheme", theme);
        },
    },
});
